// extracted by mini-css-extract-plugin
export var deliveryRow = "_qm-a";
export var fixedHeight = "_qm-4";
export var freightLogo = "_qm-9";
export var fullWidth = "_qm-3";
export var priceColumn = "_qm-5";
export var radioSelected = "_qm-7";
export var radioUnselected = "_qm-6";
export var selectedOption = "_qm-2";
export var selectedOptionContainer = "_qm-1";
export var selection = "_qm-0";
export var tallSkeletonText = "_qm-8";